import { render, staticRenderFns } from "./UpdateMaClass.vue?vue&type=template&id=f64c8a4c&scoped=true"
import script from "./UpdateMaClass.vue?vue&type=script&lang=js"
export * from "./UpdateMaClass.vue?vue&type=script&lang=js"
import style0 from "./UpdateMaClass.vue?vue&type=style&index=0&id=f64c8a4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c8a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64c8a4c')) {
      api.createRecord('f64c8a4c', component.options)
    } else {
      api.reload('f64c8a4c', component.options)
    }
    module.hot.accept("./UpdateMaClass.vue?vue&type=template&id=f64c8a4c&scoped=true", function () {
      api.rerender('f64c8a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/MaClassDialog/UpdateMaClass.vue"
export default component.exports